const localizers = {
  'loading.msg': () => `Betöltés...`,
  'SASServer.genericError.msg': () => `A kiszolgáló nem érhető el.`,
  'SASReport.genericError.msg': () => `Nem lehet betölteni a kijelölt jelentést.`,
  'SASReportImage.genericError.msg': () => `Nem sikerült betölteni a jelentésképet.`,
  'SASReportImage.imageNotSupported.msg': () => `Ennél a jelentéstartalom-típusnál nincsenek támogatva a képek.`,
}
export default localizers;
